export enum ParticipantKind {
  student = "STUDENT",
  group = "GROUP",
}
